import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.542 1.625a.75.75 0 0 0-1.025-.274l-6.754 3.9H3A1.75 1.75 0 0 0 1.25 7v14c0 .966.784 1.75 1.75 1.75h18A1.75 1.75 0 0 0 22.75 21V7A1.75 1.75 0 0 0 21 5.25h-2.365l-2.093-3.626Zm1.083 14.125h3.625v-3.5h-3.625c-1.07 0-1.875.818-1.875 1.75 0 .933.805 1.75 1.875 1.75Zm0-5h3.625V7a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v14c0 .138.112.25.25.25h18a.25.25 0 0 0 .25-.25v-3.75h-3.625c-1.829 0-3.375-1.42-3.375-3.25 0-1.829 1.546-3.25 3.375-3.25Zm-.726-5.507-5.114-.005 3.833-2.213 1.28 2.218Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }